import { render } from "./studioList.vue?vue&type=template&id=3da19c39&scoped=true"
import script from "./studioList.vue?vue&type=script&lang=js"
export * from "./studioList.vue?vue&type=script&lang=js"

import "./studioList.vue?vue&type=style&index=0&id=3da19c39&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da19c39"]])

export default __exports__